export class SoVAT {
    /**
     * Calculate TTC (including VAT) and return as number with 2 decimals
     */
    public static toTTC(amountHT?: number | null, vatRatePercent?: number | null) {
        let ttc = amountHT;
        if (amountHT && vatRatePercent) {
            ttc = amountHT * (1 + vatRatePercent / 100);
        }
        return ttc ? Number(ttc.toFixed(2)) : ttc;
    }

    /**
     * Calculate HT (excluding VAT) and return as number with 2 decimals
     */
    public static toHT(amountTTC?: number | null, vatRatePercent?: number | null) {
        let ht = amountTTC;
        if (amountTTC && vatRatePercent) {
            ht = amountTTC / (1 + vatRatePercent / 100);
        }
        return ht ? Number(ht.toFixed(2)) : ht;
    }

    /**
     * Calculate VAT amount and return as number with 2 decimals
     */
    public static vatAmount(amountHT?: number | null, vatRatePercent?: number | null) {
        let vat = amountHT;
        if (amountHT && vatRatePercent) {
            vat = amountHT * (vatRatePercent / 100);
        }
        return vat ? Number(vat.toFixed(2)) : vat;
    }
}